import AOS from "aos";
import lozad from "lozad";
import { ToggleItem, setBackgroundElement } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
$(document).ready(function () {
	header.init();
	setBackgroundElement();
	swiperInit();
	ToggleItem();
	toggleForm();
});
/*==================== Toggle form ====================*/
function toggleForm() {
	$(".section-about.section-2 .open-form-contact").on("click", function () {
		$(".section-about.section-2 .wrap-form-contact").addClass("active");
		console.log(123)
	});
	$(".section-about.section-2 .close-form").on("click", function () {
		$(".section-about.section-2 .wrap-form-contact").removeClass("active");
	});
}
/*==================== Aos Init ====================*/
AOS.init({
	offset: 100,
});
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();
